export default function ({message, success, hint}) {
    this.$store.dispatch("snackBar/displaySnackBar", {snackBarMessage: message, success, snackBarHint: hint})
}
